<!--
 * @Author: your name
 * @Date: 2020-12-21 16:48:35
 * @LastEditTime: 2020-12-25 14:03:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zcjb\src\components\ebs_card\ebs_card.vue
-->
<template>
  <div class="e-flex jc-center box mt-4 mb-4 container">
    <img :src="datas.leftImg" alt="" style="width: 200px; height: 260px" />
    <div
      style="width: 1000px; flex-warp: warp"
      class="e-flex bg-normal flex-wrap"
    >
      <div
        :style="filerBorder(index)"
        v-for="(cardItem, index) in datas.item"
        :key="index"
        class="cardBox e-flex bg-normal jc-center"
        @click="formModalShow(cardItem.title)"
      >
        <img :src="cardItem.icon" alt="" />
        <div class="e-flex flex-column text-left">
          <span class="title">{{ cardItem.title }}</span>
          <el-tooltip
            :content="cardItem.text"
            placement="bottom"
            effect="light"
          >
            <span class="content">{{ cardItem.text }}</span>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { data2 } from './Json'
export default {
  data() {
    return {
      datas: data2,
      ModalText: '',
      loansModalShow: false,
      loansForm: {},
      letterForm: {},
    }
  },
  methods: {
    formModalShow(type) {
      this.loansModalShow = true
      this.ModalText = type
    },
    filerBorder(index) {
      if (index === 0 || index === 1 || index === 2) {
        return 'border-right: 1px solid #5B9CFF'
      }
      if (index === 4 || index === 5 || index === 6) {
        return 'border-right: 1px solid #5B9CFF;border-top: 1px solid #5B9CFF'
      }
      if (index === 7) {
        return 'border-top: 1px solid #5B9CFF'
      }
      // if(4 - index + 1 == 0){
      //   return ''
      // }else if(8 - index+1 == 0 ){
      //   return ''
      // } else if(index >= 0 && index <=3 && 4 - index + 1 != 0){
      //   return 'border-right: 1px solid #333'
      // } else if(index == 0 ) {
      //   return 'border-right: 1px solid #333;border-top: 1px solid #333'
      // }
      // return 4 - index+1 == 0 ? '' : 8 - index+1 == 0 ? '' : index <= 1 ? 'border-right: 1px solid #333' :'border-right: 1px solid #333;border-top: 1px solid #333'
    },
  },
  computed: {},
}
</script>

<style scoped lang="scss">
.cardBox {
  width: 250px;
  padding: 30px 16px 0;

  img {
    width: 28px;
    height: 28px;
    margin-right: 16px;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 3px;
  }
  .content {
    font-size: 12px;
  }
}
</style>
